export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.17-1013.52",
  commitId: "17d2cd1f0fb9d77e9ba98419fe375f81db343637",
  commitTime: "2026-09-17T10:13:52.000Z",
});
